import { __commonJS, __toESM } from './chunk-65ITIFTL.mjs';
import * as React10 from 'react';
import React10__default, { memo, useState, useRef, useEffect, useMemo, Fragment, useCallback } from 'react';
import { useAddonState, useChannel, useParameter, addons, types, Consumer } from '@storybook/manager-api';
import { Button, TooltipNote, IconButton, Separator, P, Icons, Placeholder, Link, AddonPanel, Bar, WithTooltip, Spaced, Badge } from '@storybook/components';
import { CallStates, EVENTS } from '@storybook/instrumenter';
import { global } from '@storybook/global';
import { STORY_RENDER_PHASE_CHANGED, STORY_THREW_EXCEPTION, PLAY_FUNCTION_THREW_EXCEPTION, IGNORED_EXCEPTION, FORCE_REMOUNT } from '@storybook/core-events';
import { styled, typography, useTheme as useTheme$1 } from '@storybook/theming';
import { transparentize } from 'polished';
import { Icon } from '@storybook/components/experimental';

// ../../node_modules/@devtools-ds/object-inspector/node_modules/@babel/runtime/helpers/extends.js
var require_extends = __commonJS({
  "../../node_modules/@devtools-ds/object-inspector/node_modules/@babel/runtime/helpers/extends.js"(exports, module) {
    function _extends5() {
      module.exports = _extends5 = Object.assign || function(target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
      return _extends5.apply(this, arguments);
    }
    module.exports = _extends5;
  }
});

// ../../node_modules/@devtools-ds/object-inspector/node_modules/@babel/runtime/helpers/objectWithoutPropertiesLoose.js
var require_objectWithoutPropertiesLoose = __commonJS({
  "../../node_modules/@devtools-ds/object-inspector/node_modules/@babel/runtime/helpers/objectWithoutPropertiesLoose.js"(exports, module) {
    function _objectWithoutPropertiesLoose(source, excluded) {
      if (source == null)
        return {};
      var target = {};
      var sourceKeys = Object.keys(source);
      var key, i;
      for (i = 0; i < sourceKeys.length; i++) {
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0)
          continue;
        target[key] = source[key];
      }
      return target;
    }
    module.exports = _objectWithoutPropertiesLoose;
  }
});

// ../../node_modules/@devtools-ds/object-inspector/node_modules/@babel/runtime/helpers/objectWithoutProperties.js
var require_objectWithoutProperties = __commonJS({
  "../../node_modules/@devtools-ds/object-inspector/node_modules/@babel/runtime/helpers/objectWithoutProperties.js"(exports, module) {
    var objectWithoutPropertiesLoose = require_objectWithoutPropertiesLoose();
    function _objectWithoutProperties6(source, excluded) {
      if (source == null)
        return {};
      var target = objectWithoutPropertiesLoose(source, excluded);
      var key, i;
      if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for (i = 0; i < sourceSymbolKeys.length; i++) {
          key = sourceSymbolKeys[i];
          if (excluded.indexOf(key) >= 0)
            continue;
          if (!Object.prototype.propertyIsEnumerable.call(source, key))
            continue;
          target[key] = source[key];
        }
      }
      return target;
    }
    module.exports = _objectWithoutProperties6;
  }
});

// ../../node_modules/@devtools-ds/themes/node_modules/@babel/runtime/helpers/defineProperty.js
var require_defineProperty = __commonJS({
  "../../node_modules/@devtools-ds/themes/node_modules/@babel/runtime/helpers/defineProperty.js"(exports, module) {
    function _defineProperty(obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }
      return obj;
    }
    module.exports = _defineProperty;
  }
});

// ../../node_modules/@devtools-ds/themes/node_modules/@babel/runtime/helpers/objectSpread2.js
var require_objectSpread2 = __commonJS({
  "../../node_modules/@devtools-ds/themes/node_modules/@babel/runtime/helpers/objectSpread2.js"(exports, module) {
    var defineProperty = require_defineProperty();
    function ownKeys(object, enumerableOnly) {
      var keys = Object.keys(object);
      if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly)
          symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
          });
        keys.push.apply(keys, symbols);
      }
      return keys;
    }
    function _objectSpread22(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) {
          ownKeys(source, true).forEach(function(key) {
            defineProperty(target, key, source[key]);
          });
        } else if (Object.getOwnPropertyDescriptors) {
          Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        } else {
          ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
          });
        }
      }
      return target;
    }
    module.exports = _objectSpread22;
  }
});

// ../../node_modules/@devtools-ds/themes/node_modules/@babel/runtime/helpers/objectWithoutPropertiesLoose.js
var require_objectWithoutPropertiesLoose2 = __commonJS({
  "../../node_modules/@devtools-ds/themes/node_modules/@babel/runtime/helpers/objectWithoutPropertiesLoose.js"(exports, module) {
    function _objectWithoutPropertiesLoose(source, excluded) {
      if (source == null)
        return {};
      var target = {};
      var sourceKeys = Object.keys(source);
      var key, i;
      for (i = 0; i < sourceKeys.length; i++) {
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0)
          continue;
        target[key] = source[key];
      }
      return target;
    }
    module.exports = _objectWithoutPropertiesLoose;
  }
});

// ../../node_modules/@devtools-ds/themes/node_modules/@babel/runtime/helpers/objectWithoutProperties.js
var require_objectWithoutProperties2 = __commonJS({
  "../../node_modules/@devtools-ds/themes/node_modules/@babel/runtime/helpers/objectWithoutProperties.js"(exports, module) {
    var objectWithoutPropertiesLoose = require_objectWithoutPropertiesLoose2();
    function _objectWithoutProperties6(source, excluded) {
      if (source == null)
        return {};
      var target = objectWithoutPropertiesLoose(source, excluded);
      var key, i;
      if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for (i = 0; i < sourceSymbolKeys.length; i++) {
          key = sourceSymbolKeys[i];
          if (excluded.indexOf(key) >= 0)
            continue;
          if (!Object.prototype.propertyIsEnumerable.call(source, key))
            continue;
          target[key] = source[key];
        }
      }
      return target;
    }
    module.exports = _objectWithoutProperties6;
  }
});

// ../../node_modules/@devtools-ds/object-inspector/node_modules/@babel/runtime/helpers/defineProperty.js
var require_defineProperty2 = __commonJS({
  "../../node_modules/@devtools-ds/object-inspector/node_modules/@babel/runtime/helpers/defineProperty.js"(exports, module) {
    function _defineProperty(obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }
      return obj;
    }
    module.exports = _defineProperty;
  }
});

// ../../node_modules/@devtools-ds/object-inspector/node_modules/@babel/runtime/helpers/objectSpread2.js
var require_objectSpread22 = __commonJS({
  "../../node_modules/@devtools-ds/object-inspector/node_modules/@babel/runtime/helpers/objectSpread2.js"(exports, module) {
    var defineProperty = require_defineProperty2();
    function ownKeys(object, enumerableOnly) {
      var keys = Object.keys(object);
      if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly)
          symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
          });
        keys.push.apply(keys, symbols);
      }
      return keys;
    }
    function _objectSpread22(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) {
          ownKeys(source, true).forEach(function(key) {
            defineProperty(target, key, source[key]);
          });
        } else if (Object.getOwnPropertyDescriptors) {
          Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        } else {
          ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
          });
        }
      }
      return target;
    }
    module.exports = _objectSpread22;
  }
});

// ../../node_modules/@devtools-ds/tree/node_modules/@babel/runtime/helpers/extends.js
var require_extends2 = __commonJS({
  "../../node_modules/@devtools-ds/tree/node_modules/@babel/runtime/helpers/extends.js"(exports, module) {
    function _extends5() {
      module.exports = _extends5 = Object.assign || function(target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
      return _extends5.apply(this, arguments);
    }
    module.exports = _extends5;
  }
});

// ../../node_modules/@devtools-ds/tree/node_modules/@babel/runtime/helpers/objectWithoutPropertiesLoose.js
var require_objectWithoutPropertiesLoose3 = __commonJS({
  "../../node_modules/@devtools-ds/tree/node_modules/@babel/runtime/helpers/objectWithoutPropertiesLoose.js"(exports, module) {
    function _objectWithoutPropertiesLoose(source, excluded) {
      if (source == null)
        return {};
      var target = {};
      var sourceKeys = Object.keys(source);
      var key, i;
      for (i = 0; i < sourceKeys.length; i++) {
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0)
          continue;
        target[key] = source[key];
      }
      return target;
    }
    module.exports = _objectWithoutPropertiesLoose;
  }
});

// ../../node_modules/@devtools-ds/tree/node_modules/@babel/runtime/helpers/objectWithoutProperties.js
var require_objectWithoutProperties3 = __commonJS({
  "../../node_modules/@devtools-ds/tree/node_modules/@babel/runtime/helpers/objectWithoutProperties.js"(exports, module) {
    var objectWithoutPropertiesLoose = require_objectWithoutPropertiesLoose3();
    function _objectWithoutProperties6(source, excluded) {
      if (source == null)
        return {};
      var target = objectWithoutPropertiesLoose(source, excluded);
      var key, i;
      if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for (i = 0; i < sourceSymbolKeys.length; i++) {
          key = sourceSymbolKeys[i];
          if (excluded.indexOf(key) >= 0)
            continue;
          if (!Object.prototype.propertyIsEnumerable.call(source, key))
            continue;
          target[key] = source[key];
        }
      }
      return target;
    }
    module.exports = _objectWithoutProperties6;
  }
});

// src/constants.ts
var ADDON_ID = "storybook/interactions";
var PANEL_ID = `${ADDON_ID}/panel`;
var StyledBadge = styled.div(({ theme: theme2, status }) => {
  const backgroundColor = {
    [CallStates.DONE]: theme2.color.positive,
    [CallStates.ERROR]: theme2.color.negative,
    [CallStates.ACTIVE]: theme2.color.warning,
    [CallStates.WAITING]: theme2.color.warning
  }[status];
  return {
    padding: "4px 6px 4px 8px;",
    borderRadius: "4px",
    backgroundColor,
    color: "white",
    fontFamily: typography.fonts.base,
    textTransform: "uppercase",
    fontSize: typography.size.s1,
    letterSpacing: 3,
    fontWeight: typography.weight.bold,
    width: 65,
    textAlign: "center"
  };
});
var StatusBadge = ({ status }) => {
  const badgeText = {
    [CallStates.DONE]: "Pass",
    [CallStates.ERROR]: "Fail",
    [CallStates.ACTIVE]: "Runs",
    [CallStates.WAITING]: "Runs"
  }[status];
  return /* @__PURE__ */ React10__default.createElement(StyledBadge, { "aria-label": "Status of the test run", status }, badgeText);
};

// src/components/Subnav.tsx
var SubnavWrapper = styled.div(({ theme: theme2 }) => ({
  background: theme2.background.app,
  borderBottom: `1px solid ${theme2.appBorderColor}`,
  position: "sticky",
  top: 0,
  zIndex: 1
}));
var StyledSubnav = styled.nav(({ theme: theme2 }) => ({
  height: 40,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  paddingLeft: 15
}));
var StyledButton = styled(Button)(({ theme: theme2 }) => ({
  borderRadius: 4,
  padding: 6,
  color: theme2.textMutedColor,
  "&:not(:disabled)": {
    "&:hover,&:focus-visible": {
      color: theme2.color.secondary
    }
  }
}));
var Note = styled(TooltipNote)(({ theme: theme2 }) => ({
  fontFamily: theme2.typography.fonts.base
}));
var StyledIconButton = styled(IconButton)(({ theme: theme2 }) => ({
  color: theme2.textMutedColor,
  margin: "0 3px"
}));
var StyledSeparator = styled(Separator)({
  marginTop: 0
});
var StyledLocation = styled(P)(({ theme: theme2 }) => ({
  color: theme2.textMutedColor,
  justifyContent: "flex-end",
  textAlign: "right",
  whiteSpace: "nowrap",
  marginTop: "auto",
  marginBottom: 1,
  paddingRight: 15,
  fontSize: 13
}));
var Group = styled.div({
  display: "flex",
  alignItems: "center"
});
var RewindButton = styled(StyledIconButton)({
  marginLeft: 9
});
var JumpToEndButton = styled(StyledButton)({
  marginLeft: 9,
  marginRight: 9,
  marginBottom: 1,
  lineHeight: "12px"
});
var RerunButton = styled(StyledIconButton)(({ theme: theme2, animating, disabled }) => ({
  opacity: disabled ? 0.5 : 1,
  svg: {
    animation: animating && `${theme2.animation.rotate360} 200ms ease-out`
  }
}));
var Subnav = ({
  controls,
  controlStates,
  status,
  storyFileName,
  onScrollToEnd
}) => {
  const buttonText = status === CallStates.ERROR ? "Scroll to error" : "Scroll to end";
  return /* @__PURE__ */ React10__default.createElement(SubnavWrapper, null, /* @__PURE__ */ React10__default.createElement(Bar, null, /* @__PURE__ */ React10__default.createElement(StyledSubnav, null, /* @__PURE__ */ React10__default.createElement(Group, null, /* @__PURE__ */ React10__default.createElement(StatusBadge, { status }), /* @__PURE__ */ React10__default.createElement(JumpToEndButton, { onClick: onScrollToEnd, disabled: !onScrollToEnd }, buttonText), /* @__PURE__ */ React10__default.createElement(StyledSeparator, null), /* @__PURE__ */ React10__default.createElement(WithTooltip, { trigger: "hover", hasChrome: false, tooltip: /* @__PURE__ */ React10__default.createElement(Note, { note: "Go to start" }) }, /* @__PURE__ */ React10__default.createElement(
    RewindButton,
    {
      "aria-label": "Go to start",
      containsIcon: true,
      onClick: controls.start,
      disabled: !controlStates.start
    },
    /* @__PURE__ */ React10__default.createElement(Icon.Rewind, null)
  )), /* @__PURE__ */ React10__default.createElement(WithTooltip, { trigger: "hover", hasChrome: false, tooltip: /* @__PURE__ */ React10__default.createElement(Note, { note: "Go back" }) }, /* @__PURE__ */ React10__default.createElement(
    StyledIconButton,
    {
      "aria-label": "Go back",
      containsIcon: true,
      onClick: controls.back,
      disabled: !controlStates.back
    },
    /* @__PURE__ */ React10__default.createElement(Icon.PlayBack, null)
  )), /* @__PURE__ */ React10__default.createElement(WithTooltip, { trigger: "hover", hasChrome: false, tooltip: /* @__PURE__ */ React10__default.createElement(Note, { note: "Go forward" }) }, /* @__PURE__ */ React10__default.createElement(
    StyledIconButton,
    {
      "aria-label": "Go forward",
      containsIcon: true,
      onClick: controls.next,
      disabled: !controlStates.next
    },
    /* @__PURE__ */ React10__default.createElement(Icon.PlayNext, null)
  )), /* @__PURE__ */ React10__default.createElement(WithTooltip, { trigger: "hover", hasChrome: false, tooltip: /* @__PURE__ */ React10__default.createElement(Note, { note: "Go to end" }) }, /* @__PURE__ */ React10__default.createElement(
    StyledIconButton,
    {
      "aria-label": "Go to end",
      containsIcon: true,
      onClick: controls.end,
      disabled: !controlStates.end
    },
    /* @__PURE__ */ React10__default.createElement(Icon.FastForward, null)
  )), /* @__PURE__ */ React10__default.createElement(WithTooltip, { trigger: "hover", hasChrome: false, tooltip: /* @__PURE__ */ React10__default.createElement(Note, { note: "Rerun" }) }, /* @__PURE__ */ React10__default.createElement(RerunButton, { "aria-label": "Rerun", containsIcon: true, onClick: controls.rerun }, /* @__PURE__ */ React10__default.createElement(Icon.Sync, null)))), storyFileName && /* @__PURE__ */ React10__default.createElement(Group, null, /* @__PURE__ */ React10__default.createElement(StyledLocation, null, storyFileName)))));
};

// ../../node_modules/@devtools-ds/object-inspector/dist/esm/ObjectInspector.js
var import_extends4 = __toESM(require_extends());
var import_objectWithoutProperties5 = __toESM(require_objectWithoutProperties());

// ../../node_modules/clsx/dist/clsx.m.js
function toVal(mix) {
  var k, y, str = "";
  if (mix) {
    if (typeof mix === "object") {
      if (Array.isArray(mix)) {
        for (k = 0; k < mix.length; k++) {
          if (mix[k] && (y = toVal(mix[k]))) {
            str && (str += " ");
            str += y;
          }
        }
      } else {
        for (k in mix) {
          if (mix[k] && (y = toVal(k))) {
            str && (str += " ");
            str += y;
          }
        }
      }
    } else if (typeof mix !== "boolean" && !mix.call) {
      str && (str += " ");
      str += mix;
    }
  }
  return str;
}
function clsx_m_default() {
  var i = 0, x, str = "";
  while (i < arguments.length) {
    if (x = toVal(arguments[i++])) {
      str && (str += " ");
      str += x;
    }
  }
  return str;
}

// ../../node_modules/@devtools-ds/object-parser/dist/esm/index.js
var isArray = (val) => {
  return Array.isArray(val) || // Detect https://developer.mozilla.org/en-US/docs/Web/JavaScript/Typed_arrays
  ArrayBuffer.isView(val) && !(val instanceof DataView);
};
var isObject = (val) => {
  return val !== null && typeof val === "object" && !isArray(val) && !(val instanceof Date) && !(val instanceof RegExp) && !(val instanceof Error) && !(val instanceof WeakMap) && !(val instanceof WeakSet);
};
var isKnownObject = (val) => {
  return isObject(val) || isArray(val) || typeof val === "function" || val instanceof Promise;
};
var getPromiseState = (promise) => {
  const unique = /unique/;
  return Promise.race([promise, unique]).then((result) => result === unique ? ["pending"] : ["fulfilled", result], (e) => ["rejected", e]);
};
var buildAST = async (key, value, depth, sortKeys, isPrototype, showPrototype) => {
  const astNode = {
    key,
    depth,
    value,
    type: "value",
    parent: void 0
  };
  if (value && isKnownObject(value) && depth < 100) {
    const children = [];
    let t = "object";
    if (isArray(value)) {
      for (let i = 0; i < value.length; i++) {
        children.push(async () => {
          const child = await buildAST(i.toString(), value[i], depth + 1, sortKeys);
          child.parent = astNode;
          return child;
        });
      }
      t = "array";
    } else {
      const keys = Object.getOwnPropertyNames(value);
      if (sortKeys)
        keys.sort();
      for (let i = 0; i < keys.length; i++) {
        let safeValue;
        try {
          safeValue = value[keys[i]];
        } catch (e) {
        }
        children.push(async () => {
          const child = await buildAST(keys[i], safeValue, depth + 1, sortKeys);
          child.parent = astNode;
          return child;
        });
      }
      if (typeof value === "function") {
        t = "function";
      }
      if (value instanceof Promise) {
        const [status, result] = await getPromiseState(value);
        children.push(async () => {
          const child = await buildAST("<state>", status, depth + 1, sortKeys);
          child.parent = astNode;
          return child;
        });
        if (status !== "pending") {
          children.push(async () => {
            const child = await buildAST("<value>", result, depth + 1, sortKeys);
            child.parent = astNode;
            return child;
          });
        }
        t = "promise";
      }
      if (value instanceof Map) {
        const entries = Array.from(value.entries());
        const parsedEntries = entries.map((entry) => {
          const [entryKey, entryValue] = entry;
          return {
            "<key>": entryKey,
            "<value>": entryValue
          };
        });
        children.push(async () => {
          const child = await buildAST("<entries>", parsedEntries, depth + 1, sortKeys);
          child.parent = astNode;
          return child;
        });
        children.push(async () => {
          const child = await buildAST("size", value.size, depth + 1, sortKeys);
          child.parent = astNode;
          return child;
        });
        t = "map";
      }
      if (value instanceof Set) {
        const entries = Array.from(value.entries());
        const parsedEntries = entries.map((entry) => {
          return entry[1];
        });
        children.push(async () => {
          const child = await buildAST("<entries>", parsedEntries, depth + 1, sortKeys);
          child.parent = astNode;
          return child;
        });
        children.push(async () => {
          const child = await buildAST("size", value.size, depth + 1, sortKeys);
          child.parent = astNode;
          return child;
        });
        t = "set";
      }
    }
    if (value !== Object.prototype && showPrototype) {
      children.push(async () => {
        const child = await buildAST("<prototype>", Object.getPrototypeOf(value), depth + 1, sortKeys, true);
        child.parent = astNode;
        return child;
      });
    }
    astNode.type = t;
    astNode.children = children;
    astNode.isPrototype = isPrototype;
  }
  return astNode;
};
var parse = (data, sortKeys, includePrototypes) => {
  const keys = sortKeys === false ? sortKeys : true;
  const prototypes = includePrototypes === false ? includePrototypes : true;
  return buildAST("root", data, 0, keys, void 0, prototypes);
};

// ../../node_modules/@devtools-ds/themes/dist/esm/utils.js
var import_objectSpread2 = __toESM(require_objectSpread2());
var import_objectWithoutProperties = __toESM(require_objectWithoutProperties2());
var _excluded = ["children"];
var ThemeContext = /* @__PURE__ */ React10__default.createContext({
  theme: "chrome",
  colorScheme: "light"
});
var ThemeProvider = (_ref) => {
  let {
    children
  } = _ref, value = (0, import_objectWithoutProperties.default)(_ref, _excluded);
  const wrappedTheme = React10__default.useContext(ThemeContext);
  return /* @__PURE__ */ React10__default.createElement(ThemeContext.Provider, {
    value: (0, import_objectSpread2.default)((0, import_objectSpread2.default)({}, wrappedTheme), value)
  }, children);
};
var useTheme = (props, styles = {}) => {
  const themeContext = React10__default.useContext(ThemeContext);
  const currentTheme = props.theme || themeContext.theme || "chrome";
  const currentColorScheme = props.colorScheme || themeContext.colorScheme || "light";
  const themeClass = clsx_m_default(styles[currentTheme], styles[currentColorScheme]);
  return {
    currentColorScheme,
    currentTheme,
    themeClass
  };
};

// ../../node_modules/@devtools-ds/object-inspector/dist/esm/ObjectInspectorItem.js
var import_objectSpread22 = __toESM(require_objectSpread22());

// ../../node_modules/@devtools-ds/tree/dist/esm/index.js
var import_extends = __toESM(require_extends2());
var import_objectWithoutProperties2 = __toESM(require_objectWithoutProperties3());
var TreeContext = /* @__PURE__ */ React10__default.createContext({
  isChild: false,
  depth: 0,
  hasHover: true
});
var TreeContext_default = TreeContext;

// ../../node_modules/@devtools-ds/tree/dist/esm/Tree.css.js
var Tree_css_default = { "tree": "Tree-tree-fbbbe38", "item": "Tree-item-353d6f3", "group": "Tree-group-d3c3d8a", "label": "Tree-label-d819155", "focusWhite": "Tree-focusWhite-f1e00c2", "arrow": "Tree-arrow-03ab2e7", "hover": "Tree-hover-3cc4e5d", "open": "Tree-open-3f1a336", "dark": "Tree-dark-1b4aa00", "chrome": "Tree-chrome-bcbcac6", "light": "Tree-light-09174ee" };

// ../../node_modules/@devtools-ds/tree/dist/esm/index.js
var _excluded2 = ["theme", "hover", "colorScheme", "children", "label", "className", "onUpdate", "onSelect", "open"];
var Tree = (props) => {
  const {
    theme: theme2,
    hover,
    colorScheme,
    children,
    label,
    className,
    onUpdate,
    onSelect,
    open
  } = props, html = (0, import_objectWithoutProperties2.default)(props, _excluded2);
  const {
    themeClass,
    currentTheme
  } = useTheme({
    theme: theme2,
    colorScheme
  }, Tree_css_default);
  const [isOpen, setOpen] = useState(open);
  useEffect(() => {
    setOpen(open);
  }, [open]);
  const updateState = (value) => {
    setOpen(value);
    if (onUpdate)
      onUpdate(value);
  };
  const hasChildren = React10__default.Children.count(children) > 0;
  const updateFocus = (newNode, previousNode) => {
    if (newNode.isSameNode(previousNode || null))
      return;
    const focusableNode = newNode.querySelector('[tabindex="-1"]');
    focusableNode === null || focusableNode === void 0 ? void 0 : focusableNode.focus();
    newNode.setAttribute("aria-selected", "true");
    previousNode === null || previousNode === void 0 ? void 0 : previousNode.removeAttribute("aria-selected");
  };
  const getParent = (node, role) => {
    let parent = node;
    while (parent && parent.parentElement) {
      if (parent.getAttribute("role") === role) {
        return parent;
      }
      parent = parent.parentElement;
    }
    return null;
  };
  const getListElements = (node) => {
    const tree = getParent(node, "tree");
    if (!tree)
      return [];
    return Array.from(tree.querySelectorAll("li"));
  };
  const moveBack = (node) => {
    const group = getParent(node, "group");
    const toggle = group === null || group === void 0 ? void 0 : group.previousElementSibling;
    if (toggle && toggle.getAttribute("tabindex") === "-1") {
      const toggleParent = toggle.parentElement;
      const nodeParent = node.parentElement;
      updateFocus(toggleParent, nodeParent);
    }
  };
  const moveHome = (node, direction) => {
    const elements = getListElements(node);
    elements.forEach((element) => {
      element.removeAttribute("aria-selected");
    });
    if (direction === "start" && elements[0]) {
      updateFocus(elements[0]);
    }
    if (direction === "end" && elements[elements.length - 1]) {
      updateFocus(elements[elements.length - 1]);
    }
  };
  const moveFocusAdjacent = (node, direction) => {
    const elements = getListElements(node) || [];
    for (let i = 0; i < elements.length; i++) {
      const currentNode = elements[i];
      if (currentNode.getAttribute("aria-selected") === "true") {
        if (direction === "up" && elements[i - 1]) {
          updateFocus(elements[i - 1], currentNode);
        } else if (direction === "down" && elements[i + 1]) {
          updateFocus(elements[i + 1], currentNode);
        }
        return;
      }
    }
    updateFocus(elements[0]);
  };
  const handleKeypress = (event, isChild2) => {
    const node = event.target;
    if (event.key === "Enter" || event.key === " ") {
      updateState(!isOpen);
    }
    if (event.key === "ArrowRight" && isOpen && !isChild2) {
      moveFocusAdjacent(node, "down");
    } else if (event.key === "ArrowRight") {
      updateState(true);
    }
    if (event.key === "ArrowLeft" && (!isOpen || isChild2)) {
      moveBack(node);
    } else if (event.key === "ArrowLeft") {
      updateState(false);
    }
    if (event.key === "ArrowDown") {
      moveFocusAdjacent(node, "down");
    }
    if (event.key === "ArrowUp") {
      moveFocusAdjacent(node, "up");
    }
    if (event.key === "Home") {
      moveHome(node, "start");
    }
    if (event.key === "End") {
      moveHome(node, "end");
    }
  };
  const handleClick = (event, isChild2) => {
    const node = event.target;
    const parent = getParent(node, "treeitem");
    const elements = getListElements(node) || [];
    let found = false;
    for (let i = 0; i < elements.length; i++) {
      const currentNode = elements[i];
      if (currentNode.getAttribute("aria-selected") === "true") {
        if (parent) {
          found = true;
          updateFocus(parent, currentNode);
        }
        break;
      }
    }
    if (!found && parent) {
      updateFocus(parent);
    }
    if (!isChild2) {
      updateState(!isOpen);
    }
  };
  const handleBlur = (event) => {
    const node = event.currentTarget;
    if (!node.contains(document.activeElement) && node.getAttribute("role") === "tree") {
      node.setAttribute("tabindex", "0");
    }
  };
  const handleFocus = (event) => {
    const node = event.target;
    if (node.getAttribute("role") === "tree") {
      const selected = node.querySelector('[aria-selected="true"]');
      if (selected) {
        updateFocus(selected);
      } else {
        moveFocusAdjacent(node, "down");
      }
      node.setAttribute("tabindex", "-1");
    }
  };
  const handleButtonFocus = () => {
    onSelect === null || onSelect === void 0 ? void 0 : onSelect();
  };
  const getPaddingStyles = (depth2) => {
    const space = depth2 * 0.9 + 0.3;
    return {
      paddingLeft: `${space}em`,
      width: `calc(100% - ${space}em)`
    };
  };
  const {
    isChild,
    depth,
    hasHover
  } = React10__default.useContext(TreeContext_default);
  const showHover = hasHover ? hover : false;
  if (!isChild) {
    return /* @__PURE__ */ React10__default.createElement("ul", (0, import_extends.default)({
      role: "tree",
      tabIndex: 0,
      className: clsx_m_default(Tree_css_default.tree, Tree_css_default.group, themeClass, className),
      onFocus: handleFocus,
      onBlur: handleBlur
    }, html), /* @__PURE__ */ React10__default.createElement(TreeContext_default.Provider, {
      value: {
        isChild: true,
        depth: 0,
        hasHover: showHover
      }
    }, /* @__PURE__ */ React10__default.createElement(Tree, props)));
  }
  if (!hasChildren) {
    return /* @__PURE__ */ React10__default.createElement("li", (0, import_extends.default)({
      role: "treeitem",
      className: Tree_css_default.item
    }, html), /* @__PURE__ */ React10__default.createElement("div", {
      role: "button",
      className: clsx_m_default(Tree_css_default.label, {
        [Tree_css_default.hover]: showHover,
        [Tree_css_default.focusWhite]: currentTheme === "firefox"
      }),
      tabIndex: -1,
      style: getPaddingStyles(depth),
      onKeyDown: (e) => {
        handleKeypress(e, isChild);
      },
      onClick: (e) => handleClick(e, true),
      onFocus: handleButtonFocus
    }, /* @__PURE__ */ React10__default.createElement("span", null, label)));
  }
  const arrowClass = clsx_m_default(Tree_css_default.arrow, {
    [Tree_css_default.open]: isOpen
  });
  return /* @__PURE__ */ React10__default.createElement("li", {
    role: "treeitem",
    "aria-expanded": isOpen,
    className: Tree_css_default.item
  }, /* @__PURE__ */ React10__default.createElement("div", {
    role: "button",
    tabIndex: -1,
    className: clsx_m_default(Tree_css_default.label, {
      [Tree_css_default.hover]: showHover,
      [Tree_css_default.focusWhite]: currentTheme === "firefox"
    }),
    style: getPaddingStyles(depth),
    onClick: (e) => handleClick(e),
    onKeyDown: (e) => handleKeypress(e),
    onFocus: handleButtonFocus
  }, /* @__PURE__ */ React10__default.createElement("span", null, /* @__PURE__ */ React10__default.createElement("span", {
    "aria-hidden": true,
    className: arrowClass
  }), /* @__PURE__ */ React10__default.createElement("span", null, label))), /* @__PURE__ */ React10__default.createElement("ul", (0, import_extends.default)({
    role: "group",
    className: clsx_m_default(className, Tree_css_default.group)
  }, html), isOpen && React10__default.Children.map(children, (child) => {
    return /* @__PURE__ */ React10__default.createElement(TreeContext_default.Provider, {
      value: {
        isChild: true,
        depth: depth + 1,
        hasHover: showHover
      }
    }, child);
  })));
};
Tree.defaultProps = {
  open: false,
  hover: true
};

// ../../node_modules/@devtools-ds/object-inspector/dist/esm/ObjectValue.js
var import_extends2 = __toESM(require_extends());
var import_objectWithoutProperties3 = __toESM(require_objectWithoutProperties());

// ../../node_modules/@devtools-ds/object-inspector/dist/esm/ObjectInspector.css.js
var ObjectInspector_css_default = { "object-inspector": "ObjectInspector-object-inspector-0c33e82", "objectInspector": "ObjectInspector-object-inspector-0c33e82", "object-label": "ObjectInspector-object-label-b81482b", "objectLabel": "ObjectInspector-object-label-b81482b", "text": "ObjectInspector-text-25f57f3", "key": "ObjectInspector-key-4f712bb", "value": "ObjectInspector-value-f7ec2e5", "string": "ObjectInspector-string-c496000", "regex": "ObjectInspector-regex-59d45a3", "error": "ObjectInspector-error-b818698", "boolean": "ObjectInspector-boolean-2dd1642", "number": "ObjectInspector-number-a6daabb", "undefined": "ObjectInspector-undefined-3a68263", "null": "ObjectInspector-null-74acb50", "function": "ObjectInspector-function-07bbdcd", "function-decorator": "ObjectInspector-function-decorator-3d22c24", "functionDecorator": "ObjectInspector-function-decorator-3d22c24", "prototype": "ObjectInspector-prototype-f2449ee", "dark": "ObjectInspector-dark-0c96c97", "chrome": "ObjectInspector-chrome-2f3ca98", "light": "ObjectInspector-light-78bef54" };

// ../../node_modules/@devtools-ds/object-inspector/dist/esm/ObjectValue.js
var _excluded3 = ["ast", "theme", "showKey", "colorScheme", "className"];
var buildValue = (key, value, valueClass, showKey, depth) => {
  const computedKey = key.includes("-") ? `"${key}"` : key;
  const isRoot = depth <= 0;
  return /* @__PURE__ */ React10__default.createElement("span", {
    className: ObjectInspector_css_default.text
  }, !isRoot && showKey && /* @__PURE__ */ React10__default.createElement(React10__default.Fragment, null, /* @__PURE__ */ React10__default.createElement("span", {
    className: ObjectInspector_css_default.key
  }, computedKey), /* @__PURE__ */ React10__default.createElement("span", null, ":\xA0")), /* @__PURE__ */ React10__default.createElement("span", {
    className: valueClass
  }, value));
};
var ObjectValue = (props) => {
  const {
    ast,
    theme: theme2,
    showKey,
    colorScheme,
    className
  } = props, html = (0, import_objectWithoutProperties3.default)(props, _excluded3);
  const {
    themeClass
  } = useTheme({
    theme: theme2,
    colorScheme
  }, ObjectInspector_css_default);
  const [asyncValue, setAsyncValue] = useState(/* @__PURE__ */ React10__default.createElement("span", null));
  let value = /* @__PURE__ */ React10__default.createElement("span", null);
  useEffect(() => {
    if (ast.value instanceof Promise) {
      const waitForPromiseResult = async (promise) => {
        setAsyncValue(buildValue(ast.key, `Promise { "${await getPromiseState(promise)}" }`, ObjectInspector_css_default.key, showKey, ast.depth));
      };
      waitForPromiseResult(ast.value);
    }
  }, [ast, showKey]);
  if (typeof ast.value === "number" || typeof ast.value === "bigint") {
    value = buildValue(ast.key, String(ast.value), ObjectInspector_css_default.number, showKey, ast.depth);
  } else if (typeof ast.value === "boolean") {
    value = buildValue(ast.key, String(ast.value), ObjectInspector_css_default.boolean, showKey, ast.depth);
  } else if (typeof ast.value === "string") {
    value = buildValue(ast.key, `"${ast.value}"`, ObjectInspector_css_default.string, showKey, ast.depth);
  } else if (typeof ast.value === "undefined") {
    value = buildValue(ast.key, "undefined", ObjectInspector_css_default.undefined, showKey, ast.depth);
  } else if (typeof ast.value === "symbol") {
    value = buildValue(ast.key, ast.value.toString(), ObjectInspector_css_default.string, showKey, ast.depth);
  } else if (typeof ast.value === "function") {
    value = buildValue(ast.key, `${ast.value.name}()`, ObjectInspector_css_default.key, showKey, ast.depth);
  } else if (typeof ast.value === "object") {
    if (ast.value === null) {
      value = buildValue(ast.key, "null", ObjectInspector_css_default.null, showKey, ast.depth);
    } else if (Array.isArray(ast.value)) {
      value = buildValue(ast.key, `Array(${ast.value.length})`, ObjectInspector_css_default.key, showKey, ast.depth);
    } else if (ast.value instanceof Date) {
      value = buildValue(ast.key, `Date ${ast.value.toString()}`, ObjectInspector_css_default.value, showKey, ast.depth);
    } else if (ast.value instanceof RegExp) {
      value = buildValue(ast.key, ast.value.toString(), ObjectInspector_css_default.regex, showKey, ast.depth);
    } else if (ast.value instanceof Error) {
      value = buildValue(ast.key, ast.value.toString(), ObjectInspector_css_default.error, showKey, ast.depth);
    } else if (isObject(ast.value)) {
      value = buildValue(ast.key, "{\u2026}", ObjectInspector_css_default.key, showKey, ast.depth);
    } else {
      value = buildValue(ast.key, ast.value.constructor.name, ObjectInspector_css_default.key, showKey, ast.depth);
    }
  }
  return /* @__PURE__ */ React10__default.createElement("span", (0, import_extends2.default)({
    className: clsx_m_default(themeClass, className)
  }, html), asyncValue, value);
};
ObjectValue.defaultProps = {
  showKey: true
};
var ObjectValue_default = ObjectValue;

// ../../node_modules/@devtools-ds/object-inspector/dist/esm/ObjectLabel.js
var import_extends3 = __toESM(require_extends());
var import_objectWithoutProperties4 = __toESM(require_objectWithoutProperties());
var _excluded4 = ["ast", "theme", "previewMax", "open", "colorScheme", "className"];
var buildPreview = (children, previewMax, showKey) => {
  const previews = [];
  for (let i = 0; i < children.length; i++) {
    const child = children[i];
    if (!child.isPrototype) {
      previews.push(/* @__PURE__ */ React10__default.createElement(ObjectValue_default, {
        key: child.key,
        ast: child,
        showKey
      }));
      if (i < children.length - 1) {
        previews.push(", ");
      } else {
        previews.push(" ");
      }
    }
    if (child.isPrototype && i === children.length - 1) {
      previews.pop();
      previews.push(" ");
    }
    if (i === previewMax - 1 && children.length > previewMax) {
      previews.push("\u2026 ");
      break;
    }
  }
  return previews;
};
var getArrayLabel = (ast, open, previewMax, theme2) => {
  const l = ast.value.length;
  if (open) {
    return /* @__PURE__ */ React10__default.createElement("span", null, "Array(", l, ")");
  }
  return /* @__PURE__ */ React10__default.createElement(React10__default.Fragment, null, /* @__PURE__ */ React10__default.createElement("span", null, `${theme2 === "firefox" ? "Array" : ""}(${l}) [ `), buildPreview(ast.children, previewMax, false), /* @__PURE__ */ React10__default.createElement("span", null, "]"));
};
var getObjectLabel = (ast, open, previewMax, theme2) => {
  if (ast.isPrototype) {
    return /* @__PURE__ */ React10__default.createElement("span", null, `Object ${theme2 === "firefox" ? "{ \u2026 }" : ""}`);
  }
  if (open) {
    return /* @__PURE__ */ React10__default.createElement("span", null, "{\u2026}");
  }
  return /* @__PURE__ */ React10__default.createElement(React10__default.Fragment, null, /* @__PURE__ */ React10__default.createElement("span", null, `${theme2 === "firefox" ? "Object " : ""}{ `), buildPreview(ast.children, previewMax, true), /* @__PURE__ */ React10__default.createElement("span", null, "}"));
};
var getPromiseLabel = (ast, open, previewMax) => {
  if (open) {
    return /* @__PURE__ */ React10__default.createElement("span", null, `Promise { "${String(ast.children[0].value)}" }`);
  }
  return /* @__PURE__ */ React10__default.createElement(React10__default.Fragment, null, /* @__PURE__ */ React10__default.createElement("span", null, `Promise { `), buildPreview(ast.children, previewMax, true), /* @__PURE__ */ React10__default.createElement("span", null, "}"));
};
var getMapLabel = (ast, open, previewMax, theme2) => {
  const {
    size
  } = ast.value;
  if (open) {
    return /* @__PURE__ */ React10__default.createElement("span", null, `Map(${size})`);
  }
  return /* @__PURE__ */ React10__default.createElement(React10__default.Fragment, null, /* @__PURE__ */ React10__default.createElement("span", null, `Map${theme2 === "chrome" ? `(${size})` : ""} { `), buildPreview(ast.children, previewMax, true), /* @__PURE__ */ React10__default.createElement("span", null, "}"));
};
var getSetLabel = (ast, open, previewMax) => {
  const {
    size
  } = ast.value;
  if (open) {
    return /* @__PURE__ */ React10__default.createElement("span", null, "Set(", size, ")");
  }
  return /* @__PURE__ */ React10__default.createElement(React10__default.Fragment, null, /* @__PURE__ */ React10__default.createElement("span", null, `Set(${ast.value.size}) {`), buildPreview(ast.children, previewMax, true), /* @__PURE__ */ React10__default.createElement("span", null, "}"));
};
var ObjectLabel = (props) => {
  const {
    ast,
    theme: theme2,
    previewMax,
    open,
    colorScheme,
    className
  } = props, html = (0, import_objectWithoutProperties4.default)(props, _excluded4);
  const {
    themeClass,
    currentTheme
  } = useTheme({
    theme: theme2,
    colorScheme
  }, ObjectInspector_css_default);
  const isPrototype = ast.isPrototype || false;
  const classes = clsx_m_default(ObjectInspector_css_default.objectLabel, themeClass, className, {
    [ObjectInspector_css_default.prototype]: isPrototype
  });
  const isRoot = ast.depth <= 0;
  const Key = () => {
    return /* @__PURE__ */ React10__default.createElement("span", {
      className: isPrototype ? ObjectInspector_css_default.prototype : ObjectInspector_css_default.key
    }, isRoot ? "" : `${ast.key}: `);
  };
  if (ast.type === "array") {
    return /* @__PURE__ */ React10__default.createElement("span", (0, import_extends3.default)({
      className: classes
    }, html), /* @__PURE__ */ React10__default.createElement(Key, null), getArrayLabel(ast, open, previewMax, currentTheme));
  }
  if (ast.type === "function") {
    return /* @__PURE__ */ React10__default.createElement("span", (0, import_extends3.default)({
      className: classes
    }, html), /* @__PURE__ */ React10__default.createElement(Key, null), currentTheme === "chrome" && /* @__PURE__ */ React10__default.createElement("span", {
      className: ObjectInspector_css_default.functionDecorator
    }, "\u0192 "), /* @__PURE__ */ React10__default.createElement("span", {
      className: clsx_m_default({
        [ObjectInspector_css_default.function]: !isPrototype
      })
    }, `${ast.value.name}()`));
  }
  if (ast.type === "promise") {
    return /* @__PURE__ */ React10__default.createElement("span", (0, import_extends3.default)({
      className: classes
    }, html), /* @__PURE__ */ React10__default.createElement(Key, null), getPromiseLabel(ast, open, previewMax));
  }
  if (ast.type === "map") {
    return /* @__PURE__ */ React10__default.createElement("span", (0, import_extends3.default)({
      className: classes
    }, html), /* @__PURE__ */ React10__default.createElement(Key, null), getMapLabel(ast, open, previewMax, currentTheme));
  }
  if (ast.type === "set") {
    return /* @__PURE__ */ React10__default.createElement("span", (0, import_extends3.default)({
      className: classes
    }, html), /* @__PURE__ */ React10__default.createElement(Key, null), getSetLabel(ast, open, previewMax));
  }
  return /* @__PURE__ */ React10__default.createElement("span", (0, import_extends3.default)({
    className: classes
  }, html), /* @__PURE__ */ React10__default.createElement(Key, null), getObjectLabel(ast, open, previewMax, currentTheme));
};
ObjectLabel.defaultProps = {
  previewMax: 8,
  open: false
};
var ObjectLabel_default = ObjectLabel;

// ../../node_modules/@devtools-ds/object-inspector/dist/esm/ObjectInspectorItem.js
var ObjectInspectorItem = (props) => {
  const {
    ast,
    expandLevel,
    depth
  } = props;
  const [resolved, setResolved] = useState();
  const [open, setOpen] = useState(Boolean(depth < expandLevel));
  useEffect(() => {
    const resolve = async () => {
      if (ast.type !== "value") {
        const promises = ast.children.map((f) => f());
        const children = await Promise.all(promises);
        const r = (0, import_objectSpread22.default)((0, import_objectSpread22.default)({}, ast), {}, {
          children
        });
        setResolved(r);
      }
    };
    resolve();
  }, [ast]);
  if (resolved) {
    return /* @__PURE__ */ React10__default.createElement(Tree, {
      hover: false,
      open,
      label: /* @__PURE__ */ React10__default.createElement(ObjectLabel_default, {
        open,
        ast: resolved
      }),
      onSelect: () => {
        var _props$onSelect;
        (_props$onSelect = props.onSelect) === null || _props$onSelect === void 0 ? void 0 : _props$onSelect.call(props, ast);
      },
      onUpdate: (value) => {
        setOpen(value);
      }
    }, resolved.children.map((child) => {
      return /* @__PURE__ */ React10__default.createElement(ObjectInspectorItem, {
        key: child.key,
        ast: child,
        depth: depth + 1,
        expandLevel,
        onSelect: props.onSelect
      });
    }));
  }
  return /* @__PURE__ */ React10__default.createElement(Tree, {
    hover: false,
    label: /* @__PURE__ */ React10__default.createElement(ObjectValue_default, {
      ast
    }),
    onSelect: () => {
      var _props$onSelect2;
      (_props$onSelect2 = props.onSelect) === null || _props$onSelect2 === void 0 ? void 0 : _props$onSelect2.call(props, ast);
    }
  });
};
ObjectInspectorItem.defaultProps = {
  expandLevel: 0,
  depth: 0
};
var ObjectInspectorItem_default = ObjectInspectorItem;

// ../../node_modules/@devtools-ds/object-inspector/dist/esm/ObjectInspector.js
var _excluded5 = ["data", "expandLevel", "sortKeys", "includePrototypes", "className", "theme", "colorScheme", "onSelect"];
var ObjectInspector = (props) => {
  const {
    data,
    expandLevel,
    sortKeys,
    includePrototypes,
    className,
    theme: theme2,
    colorScheme,
    onSelect
  } = props, html = (0, import_objectWithoutProperties5.default)(props, _excluded5);
  const [ast, setAST] = useState(void 0);
  const {
    themeClass,
    currentTheme,
    currentColorScheme
  } = useTheme({
    theme: theme2,
    colorScheme
  }, ObjectInspector_css_default);
  useEffect(() => {
    const runParser = async () => {
      setAST(await parse(data, sortKeys, includePrototypes));
    };
    runParser();
  }, [data, sortKeys, includePrototypes]);
  return /* @__PURE__ */ React10__default.createElement("div", (0, import_extends4.default)({
    className: clsx_m_default(ObjectInspector_css_default.objectInspector, className, themeClass)
  }, html), ast && /* @__PURE__ */ React10__default.createElement(ThemeProvider, {
    theme: currentTheme,
    colorScheme: currentColorScheme
  }, /* @__PURE__ */ React10__default.createElement(ObjectInspectorItem_default, {
    ast,
    expandLevel,
    onSelect
  })));
};
ObjectInspector.defaultProps = {
  expandLevel: 0,
  sortKeys: true,
  includePrototypes: true
};
var colorsLight = {
  base: "#444",
  nullish: "#7D99AA",
  string: "#16B242",
  number: "#5D40D0",
  boolean: "#f41840",
  objectkey: "#698394",
  instance: "#A15C20",
  function: "#EA7509",
  muted: "#7D99AA",
  tag: {
    name: "#6F2CAC",
    suffix: "#1F99E5"
  },
  date: "#459D9C",
  error: {
    name: "#D43900",
    message: "#444"
  },
  regex: {
    source: "#A15C20",
    flags: "#EA7509"
  },
  meta: "#EA7509",
  method: "#0271B6"
};
var colorsDark = {
  base: "#eee",
  nullish: "#aaa",
  string: "#5FE584",
  number: "#6ba5ff",
  boolean: "#ff4191",
  objectkey: "#accfe6",
  instance: "#E3B551",
  function: "#E3B551",
  muted: "#aaa",
  tag: {
    name: "#f57bff",
    suffix: "#8EB5FF"
  },
  date: "#70D4D3",
  error: {
    name: "#f40",
    message: "#eee"
  },
  regex: {
    source: "#FAD483",
    flags: "#E3B551"
  },
  meta: "#FAD483",
  method: "#5EC1FF"
};
var useThemeColors = () => {
  const { base } = useTheme$1();
  return base === "dark" ? colorsDark : colorsLight;
};
var special = /[^A-Z0-9]/i;
var trimEnd = /[\s.,…]+$/gm;
var ellipsize = (string, maxlength) => {
  if (string.length <= maxlength)
    return string;
  for (let i = maxlength - 1; i >= 0; i -= 1) {
    if (special.test(string[i]) && i > 10) {
      return `${string.slice(0, i).replace(trimEnd, "")}\u2026`;
    }
  }
  return `${string.slice(0, maxlength).replace(trimEnd, "")}\u2026`;
};
var stringify = (value) => {
  try {
    return JSON.stringify(value, null, 1);
  } catch (e) {
    return String(value);
  }
};
var interleave = (nodes, separator) => nodes.flatMap(
  (node, index) => index === nodes.length - 1 ? [node] : [node, React10__default.cloneElement(separator, { key: `sep${index}` })]
);
var Node = ({
  value,
  nested,
  showObjectInspector,
  callsById,
  ...props
}) => {
  switch (true) {
    case value === null:
      return /* @__PURE__ */ React10__default.createElement(NullNode, { ...props });
    case value === void 0:
      return /* @__PURE__ */ React10__default.createElement(UndefinedNode, { ...props });
    case Array.isArray(value):
      return /* @__PURE__ */ React10__default.createElement(ArrayNode, { ...props, value, callsById });
    case typeof value === "string":
      return /* @__PURE__ */ React10__default.createElement(StringNode, { ...props, value });
    case typeof value === "number":
      return /* @__PURE__ */ React10__default.createElement(NumberNode, { ...props, value });
    case typeof value === "boolean":
      return /* @__PURE__ */ React10__default.createElement(BooleanNode, { ...props, value });
    case Object.prototype.hasOwnProperty.call(value, "__date__"):
      return /* @__PURE__ */ React10__default.createElement(DateNode, { ...props, ...value.__date__ });
    case Object.prototype.hasOwnProperty.call(value, "__error__"):
      return /* @__PURE__ */ React10__default.createElement(ErrorNode, { ...props, ...value.__error__ });
    case Object.prototype.hasOwnProperty.call(value, "__regexp__"):
      return /* @__PURE__ */ React10__default.createElement(RegExpNode, { ...props, ...value.__regexp__ });
    case Object.prototype.hasOwnProperty.call(value, "__function__"):
      return /* @__PURE__ */ React10__default.createElement(FunctionNode, { ...props, ...value.__function__ });
    case Object.prototype.hasOwnProperty.call(value, "__symbol__"):
      return /* @__PURE__ */ React10__default.createElement(SymbolNode, { ...props, ...value.__symbol__ });
    case Object.prototype.hasOwnProperty.call(value, "__element__"):
      return /* @__PURE__ */ React10__default.createElement(ElementNode, { ...props, ...value.__element__ });
    case Object.prototype.hasOwnProperty.call(value, "__class__"):
      return /* @__PURE__ */ React10__default.createElement(ClassNode, { ...props, ...value.__class__ });
    case Object.prototype.hasOwnProperty.call(value, "__callId__"):
      return /* @__PURE__ */ React10__default.createElement(MethodCall, { call: callsById.get(value.__callId__), callsById });
    case Object.prototype.toString.call(value) === "[object Object]":
      return /* @__PURE__ */ React10__default.createElement(
        ObjectNode,
        {
          value,
          showInspector: showObjectInspector,
          callsById,
          ...props
        }
      );
    default:
      return /* @__PURE__ */ React10__default.createElement(OtherNode, { value, ...props });
  }
};
var NullNode = (props) => {
  const colors2 = useThemeColors();
  return /* @__PURE__ */ React10__default.createElement("span", { style: { color: colors2.nullish }, ...props }, "null");
};
var UndefinedNode = (props) => {
  const colors2 = useThemeColors();
  return /* @__PURE__ */ React10__default.createElement("span", { style: { color: colors2.nullish }, ...props }, "undefined");
};
var StringNode = ({ value, ...props }) => {
  const colors2 = useThemeColors();
  return /* @__PURE__ */ React10__default.createElement("span", { style: { color: colors2.string }, ...props }, JSON.stringify(ellipsize(value, 50)));
};
var NumberNode = ({ value, ...props }) => {
  const colors2 = useThemeColors();
  return /* @__PURE__ */ React10__default.createElement("span", { style: { color: colors2.number }, ...props }, value);
};
var BooleanNode = ({ value, ...props }) => {
  const colors2 = useThemeColors();
  return /* @__PURE__ */ React10__default.createElement("span", { style: { color: colors2.boolean }, ...props }, String(value));
};
var ArrayNode = ({
  value,
  nested = false,
  callsById
}) => {
  const colors2 = useThemeColors();
  if (nested) {
    return /* @__PURE__ */ React10__default.createElement("span", { style: { color: colors2.base } }, "[\u2026]");
  }
  const nodes = value.slice(0, 3).map((v) => /* @__PURE__ */ React10__default.createElement(Node, { key: JSON.stringify(v), value: v, nested: true, callsById }));
  const nodelist = interleave(nodes, /* @__PURE__ */ React10__default.createElement("span", null, ", "));
  if (value.length <= 3) {
    return /* @__PURE__ */ React10__default.createElement("span", { style: { color: colors2.base } }, "[", nodelist, "]");
  }
  return /* @__PURE__ */ React10__default.createElement("span", { style: { color: colors2.base } }, "(", value.length, ") [", nodelist, ", \u2026]");
};
var ObjectNode = ({
  showInspector,
  value,
  callsById,
  nested = false
}) => {
  const isDarkMode = useTheme$1().base === "dark";
  const colors2 = useThemeColors();
  if (showInspector) {
    return /* @__PURE__ */ React10__default.createElement(React10__default.Fragment, null, /* @__PURE__ */ React10__default.createElement(
      ObjectInspector,
      {
        id: "interactions-object-inspector",
        data: value,
        includePrototypes: false,
        colorScheme: isDarkMode ? "dark" : "light"
      }
    ));
  }
  if (nested) {
    return /* @__PURE__ */ React10__default.createElement("span", { style: { color: colors2.base } }, "{\u2026}");
  }
  const nodelist = interleave(
    Object.entries(value).slice(0, 2).map(([k, v]) => /* @__PURE__ */ React10__default.createElement(Fragment, { key: k }, /* @__PURE__ */ React10__default.createElement("span", { style: { color: colors2.objectkey } }, k, ": "), /* @__PURE__ */ React10__default.createElement(Node, { value: v, callsById, nested: true }))),
    /* @__PURE__ */ React10__default.createElement("span", null, ", ")
  );
  if (Object.keys(value).length <= 2) {
    return /* @__PURE__ */ React10__default.createElement("span", { style: { color: colors2.base } }, "{ ", nodelist, " }");
  }
  return /* @__PURE__ */ React10__default.createElement("span", { style: { color: colors2.base } }, "(", Object.keys(value).length, ") ", "{ ", nodelist, ", \u2026 }");
};
var ClassNode = ({ name }) => {
  const colors2 = useThemeColors();
  return /* @__PURE__ */ React10__default.createElement("span", { style: { color: colors2.instance } }, name);
};
var FunctionNode = ({ name }) => {
  const colors2 = useThemeColors();
  return name ? /* @__PURE__ */ React10__default.createElement("span", { style: { color: colors2.function } }, name) : /* @__PURE__ */ React10__default.createElement("span", { style: { color: colors2.nullish, fontStyle: "italic" } }, "anonymous");
};
var ElementNode = ({
  prefix,
  localName,
  id,
  classNames = [],
  innerText
}) => {
  const name = prefix ? `${prefix}:${localName}` : localName;
  const colors2 = useThemeColors();
  return /* @__PURE__ */ React10__default.createElement("span", { style: { wordBreak: "keep-all" } }, /* @__PURE__ */ React10__default.createElement("span", { key: `${name}_lt`, style: { color: colors2.muted } }, "<"), /* @__PURE__ */ React10__default.createElement("span", { key: `${name}_tag`, style: { color: colors2.tag.name } }, name), /* @__PURE__ */ React10__default.createElement("span", { key: `${name}_suffix`, style: { color: colors2.tag.suffix } }, id ? `#${id}` : classNames.reduce((acc, className) => `${acc}.${className}`, "")), /* @__PURE__ */ React10__default.createElement("span", { key: `${name}_gt`, style: { color: colors2.muted } }, ">"), !id && classNames.length === 0 && innerText && /* @__PURE__ */ React10__default.createElement(React10__default.Fragment, null, /* @__PURE__ */ React10__default.createElement("span", { key: `${name}_text` }, innerText), /* @__PURE__ */ React10__default.createElement("span", { key: `${name}_close_lt`, style: { color: colors2.muted } }, "<"), /* @__PURE__ */ React10__default.createElement("span", { key: `${name}_close_tag`, style: { color: colors2.tag.name } }, "/", name), /* @__PURE__ */ React10__default.createElement("span", { key: `${name}_close_gt`, style: { color: colors2.muted } }, ">")));
};
var DateNode = ({ value }) => {
  const [date, time, ms] = value.split(/[T.Z]/);
  const colors2 = useThemeColors();
  return /* @__PURE__ */ React10__default.createElement("span", { style: { whiteSpace: "nowrap", color: colors2.date } }, date, /* @__PURE__ */ React10__default.createElement("span", { style: { opacity: 0.7 } }, "T"), time === "00:00:00" ? /* @__PURE__ */ React10__default.createElement("span", { style: { opacity: 0.7 } }, time) : time, ms === "000" ? /* @__PURE__ */ React10__default.createElement("span", { style: { opacity: 0.7 } }, ".", ms) : `.${ms}`, /* @__PURE__ */ React10__default.createElement("span", { style: { opacity: 0.7 } }, "Z"));
};
var ErrorNode = ({ name, message }) => {
  const colors2 = useThemeColors();
  return /* @__PURE__ */ React10__default.createElement("span", { style: { color: colors2.error.name } }, name, message && ": ", message && /* @__PURE__ */ React10__default.createElement("span", { style: { color: colors2.error.message }, title: message.length > 50 ? message : "" }, ellipsize(message, 50)));
};
var RegExpNode = ({ flags, source }) => {
  const colors2 = useThemeColors();
  return /* @__PURE__ */ React10__default.createElement("span", { style: { whiteSpace: "nowrap", color: colors2.regex.flags } }, "/", /* @__PURE__ */ React10__default.createElement("span", { style: { color: colors2.regex.source } }, source), "/", flags);
};
var SymbolNode = ({ description }) => {
  const colors2 = useThemeColors();
  return /* @__PURE__ */ React10__default.createElement("span", { style: { whiteSpace: "nowrap", color: colors2.instance } }, "Symbol(", description && /* @__PURE__ */ React10__default.createElement("span", { style: { color: colors2.meta } }, '"', description, '"'), ")");
};
var OtherNode = ({ value }) => {
  const colors2 = useThemeColors();
  return /* @__PURE__ */ React10__default.createElement("span", { style: { color: colors2.meta } }, stringify(value));
};
var StepNode = ({ label }) => {
  const colors2 = useThemeColors();
  const { typography: typography4 } = useTheme$1();
  return /* @__PURE__ */ React10__default.createElement(
    "span",
    {
      style: {
        color: colors2.base,
        fontFamily: typography4.fonts.base,
        fontSize: typography4.size.s2 - 1
      }
    },
    label
  );
};
var MethodCall = ({
  call,
  callsById
}) => {
  if (!call)
    return null;
  if (call.method === "step" && call.path.length === 0) {
    return /* @__PURE__ */ React10__default.createElement(StepNode, { label: call.args[0] });
  }
  const path = call.path.flatMap((elem, index) => {
    const callId = elem.__callId__;
    return [
      callId ? /* @__PURE__ */ React10__default.createElement(MethodCall, { key: `elem${index}`, call: callsById.get(callId), callsById }) : /* @__PURE__ */ React10__default.createElement("span", { key: `elem${index}` }, elem),
      /* @__PURE__ */ React10__default.createElement("wbr", { key: `wbr${index}` }),
      /* @__PURE__ */ React10__default.createElement("span", { key: `dot${index}` }, ".")
    ];
  });
  const args = call.args.flatMap((arg, index, array) => {
    const node = /* @__PURE__ */ React10__default.createElement(Node, { key: `node${index}`, value: arg, callsById });
    return index < array.length - 1 ? [node, /* @__PURE__ */ React10__default.createElement("span", { key: `comma${index}` }, ",\xA0"), /* @__PURE__ */ React10__default.createElement("wbr", { key: `wbr${index}` })] : [node];
  });
  const colors2 = useThemeColors();
  return /* @__PURE__ */ React10__default.createElement(React10__default.Fragment, null, /* @__PURE__ */ React10__default.createElement("span", { style: { color: colors2.base } }, path), /* @__PURE__ */ React10__default.createElement("span", { style: { color: colors2.method } }, call.method), /* @__PURE__ */ React10__default.createElement("span", { style: { color: colors2.base } }, "(", /* @__PURE__ */ React10__default.createElement("wbr", null), args, /* @__PURE__ */ React10__default.createElement("wbr", null), ")"));
};

// src/components/MatcherResult.tsx
var getParams = (line, fromIndex = 0) => {
  for (let i = fromIndex, depth = 1; i < line.length; i += 1) {
    if (line[i] === "(")
      depth += 1;
    else if (line[i] === ")")
      depth -= 1;
    if (depth === 0)
      return line.slice(fromIndex, i);
  }
  return "";
};
var parseValue = (value) => {
  try {
    return value === "undefined" ? void 0 : JSON.parse(value);
  } catch (e) {
    return value;
  }
};
var StyledExpected = styled.span(({ theme: theme2 }) => ({
  color: theme2.base === "light" ? theme2.color.positiveText : theme2.color.positive
}));
var StyledReceived = styled.span(({ theme: theme2 }) => ({
  color: theme2.base === "light" ? theme2.color.negativeText : theme2.color.negative
}));
var Received = ({ value, parsed }) => parsed ? /* @__PURE__ */ React10__default.createElement(Node, { showObjectInspector: true, value, style: { color: "#D43900" } }) : /* @__PURE__ */ React10__default.createElement(StyledReceived, null, value);
var Expected = ({ value, parsed }) => {
  if (parsed) {
    if (typeof value === "string" && value.startsWith("called with")) {
      return /* @__PURE__ */ React10__default.createElement(React10__default.Fragment, null, value);
    }
    return /* @__PURE__ */ React10__default.createElement(Node, { showObjectInspector: true, value, style: { color: "#16B242" } });
  }
  return /* @__PURE__ */ React10__default.createElement(StyledExpected, null, value);
};
var MatcherResult = ({ message }) => {
  const lines = message.split("\n");
  return /* @__PURE__ */ React10__default.createElement(
    "pre",
    {
      style: {
        margin: 0,
        padding: "8px 10px 8px 36px",
        fontSize: typography.size.s1
      }
    },
    lines.flatMap((line, index) => {
      if (line.startsWith("expect(")) {
        const received = getParams(line, 7);
        const remainderIndex = received && 7 + received.length;
        const matcher = received && line.slice(remainderIndex).match(/\.(to|last|nth)[A-Z]\w+\(/);
        if (matcher) {
          const expectedIndex = remainderIndex + matcher.index + matcher[0].length;
          const expected = getParams(line, expectedIndex);
          if (expected) {
            return [
              "expect(",
              /* @__PURE__ */ React10__default.createElement(Received, { key: `received_${received}`, value: received }),
              line.slice(remainderIndex, expectedIndex),
              /* @__PURE__ */ React10__default.createElement(Expected, { key: `expected_${expected}`, value: expected }),
              line.slice(expectedIndex + expected.length),
              /* @__PURE__ */ React10__default.createElement("br", { key: `br${index}` })
            ];
          }
        }
      }
      if (line.match(/^\s*- /)) {
        return [/* @__PURE__ */ React10__default.createElement(Expected, { key: line + index, value: line }), /* @__PURE__ */ React10__default.createElement("br", { key: `br${index}` })];
      }
      if (line.match(/^\s*\+ /)) {
        return [/* @__PURE__ */ React10__default.createElement(Received, { key: line + index, value: line }), /* @__PURE__ */ React10__default.createElement("br", { key: `br${index}` })];
      }
      const [, assertionLabel, assertionValue] = line.match(/^(Expected|Received): (.*)$/) || [];
      if (assertionLabel && assertionValue) {
        return assertionLabel === "Expected" ? [
          "Expected: ",
          /* @__PURE__ */ React10__default.createElement(Expected, { key: line + index, value: parseValue(assertionValue), parsed: true }),
          /* @__PURE__ */ React10__default.createElement("br", { key: `br${index}` })
        ] : [
          "Received: ",
          /* @__PURE__ */ React10__default.createElement(Received, { key: line + index, value: parseValue(assertionValue), parsed: true }),
          /* @__PURE__ */ React10__default.createElement("br", { key: `br${index}` })
        ];
      }
      const [, prefix, numberOfCalls] = line.match(/(Expected number|Received number|Number) of calls: (\d+)$/i) || [];
      if (prefix && numberOfCalls) {
        return [
          `${prefix} of calls: `,
          /* @__PURE__ */ React10__default.createElement(Node, { key: line + index, value: Number(numberOfCalls) }),
          /* @__PURE__ */ React10__default.createElement("br", { key: `br${index}` })
        ];
      }
      const [, receivedValue] = line.match(/^Received has value: (.+)$/) || [];
      if (receivedValue) {
        return [
          "Received has value: ",
          /* @__PURE__ */ React10__default.createElement(Node, { key: line + index, value: parseValue(receivedValue) }),
          /* @__PURE__ */ React10__default.createElement("br", { key: `br${index}` })
        ];
      }
      return [/* @__PURE__ */ React10__default.createElement("span", { key: line + index }, line), /* @__PURE__ */ React10__default.createElement("br", { key: `br${index}` })];
    })
  );
};

// src/theme.ts
var colors = {
  pure: {
    gray: {
      500: "#CCCCCC"
    }
  }
};
var theme = {
  colors
};
var theme_default = theme;

// src/components/StatusIcon.tsx
var {
  colors: {
    pure: { gray }
  }
} = theme_default;
var StyledStatusIcon = styled(Icons)(({ theme: theme2, status }) => {
  const color = {
    [CallStates.DONE]: theme2.color.positive,
    [CallStates.ERROR]: theme2.color.negative,
    [CallStates.ACTIVE]: theme2.color.secondary,
    [CallStates.WAITING]: transparentize(0.5, gray[500])
  }[status];
  return {
    width: status === CallStates.WAITING ? 6 : 12,
    height: status === CallStates.WAITING ? 6 : 12,
    color,
    justifySelf: "center"
  };
});
var StatusIcon = ({ status, className }) => {
  const icon = {
    [CallStates.DONE]: "check",
    [CallStates.ERROR]: "stopalt",
    [CallStates.ACTIVE]: "play",
    [CallStates.WAITING]: "circle"
  }[status];
  return /* @__PURE__ */ React10__default.createElement(
    StyledStatusIcon,
    {
      "data-testid": `icon-${status}`,
      status,
      icon,
      className
    }
  );
};

// src/components/Interaction.tsx
var MethodCallWrapper = styled.div(() => ({
  fontFamily: typography.fonts.mono,
  fontSize: typography.size.s1,
  overflowWrap: "break-word",
  inlineSize: "calc( 100% - 40px )"
}));
var RowContainer = styled("div", {
  shouldForwardProp: (prop) => !["call", "pausedAt"].includes(prop.toString())
})(
  ({ theme: theme2, call }) => ({
    position: "relative",
    display: "flex",
    flexDirection: "column",
    borderBottom: `1px solid ${theme2.appBorderColor}`,
    fontFamily: typography.fonts.base,
    fontSize: 13,
    ...call.status === CallStates.ERROR && {
      backgroundColor: theme2.base === "dark" ? transparentize(0.93, theme2.color.negative) : theme2.background.warning
    },
    paddingLeft: call.ancestors.length * 20
  }),
  ({ theme: theme2, call, pausedAt }) => pausedAt === call.id && {
    "&::before": {
      content: '""',
      position: "absolute",
      top: -5,
      zIndex: 1,
      borderTop: "4.5px solid transparent",
      borderLeft: `7px solid ${theme2.color.warning}`,
      borderBottom: "4.5px solid transparent"
    },
    "&::after": {
      content: '""',
      position: "absolute",
      top: -1,
      zIndex: 1,
      width: "100%",
      borderTop: `1.5px solid ${theme2.color.warning}`
    }
  }
);
var RowHeader = styled.div(({ theme: theme2, isInteractive }) => ({
  display: "flex",
  "&:hover": isInteractive ? {} : { background: theme2.background.hoverable }
}));
var RowLabel = styled("button", {
  shouldForwardProp: (prop) => !["call"].includes(prop.toString())
})(({ theme: theme2, disabled, call }) => ({
  flex: 1,
  display: "grid",
  background: "none",
  border: 0,
  gridTemplateColumns: "15px 1fr",
  alignItems: "center",
  minHeight: 40,
  margin: 0,
  padding: "8px 15px",
  textAlign: "start",
  cursor: disabled || call.status === CallStates.ERROR ? "default" : "pointer",
  "&:focus-visible": {
    outline: 0,
    boxShadow: `inset 3px 0 0 0 ${call.status === CallStates.ERROR ? theme2.color.warning : theme2.color.secondary}`,
    background: call.status === CallStates.ERROR ? "transparent" : theme2.background.hoverable
  },
  "& > div": {
    opacity: call.status === CallStates.WAITING ? 0.5 : 1
  }
}));
var RowActions = styled.div({
  padding: 6
});
var StyledIconButton2 = styled(IconButton)(({ theme: theme2 }) => ({
  color: theme2.textMutedColor,
  margin: "0 3px"
}));
var Note2 = styled(TooltipNote)(({ theme: theme2 }) => ({
  fontFamily: theme2.typography.fonts.base
}));
var RowMessage = styled("div")(({ theme: theme2 }) => ({
  padding: "8px 10px 8px 36px",
  fontSize: typography.size.s1,
  color: theme2.color.defaultText,
  pre: {
    margin: 0,
    padding: 0
  }
}));
var Exception = ({ exception }) => {
  if (exception.message.startsWith("expect(")) {
    return /* @__PURE__ */ React10.createElement(MatcherResult, { ...exception });
  }
  const paragraphs = exception.message.split("\n\n");
  const more = paragraphs.length > 1;
  return /* @__PURE__ */ React10.createElement(RowMessage, null, /* @__PURE__ */ React10.createElement("pre", null, paragraphs[0]), more && /* @__PURE__ */ React10.createElement("p", null, "See the full stack trace in the browser console."));
};
var Interaction = ({
  call,
  callsById,
  controls,
  controlStates,
  childCallIds,
  isHidden,
  isCollapsed,
  toggleCollapsed,
  pausedAt
}) => {
  const [isHovered, setIsHovered] = React10.useState(false);
  const isInteractive = !controlStates.goto || !call.interceptable || !!call.ancestors.length;
  if (isHidden)
    return null;
  return /* @__PURE__ */ React10.createElement(RowContainer, { call, pausedAt }, /* @__PURE__ */ React10.createElement(RowHeader, { isInteractive }, /* @__PURE__ */ React10.createElement(
    RowLabel,
    {
      "aria-label": "Interaction step",
      call,
      onClick: () => controls.goto(call.id),
      disabled: isInteractive,
      onMouseEnter: () => controlStates.goto && setIsHovered(true),
      onMouseLeave: () => controlStates.goto && setIsHovered(false)
    },
    /* @__PURE__ */ React10.createElement(StatusIcon, { status: isHovered ? CallStates.ACTIVE : call.status }),
    /* @__PURE__ */ React10.createElement(MethodCallWrapper, { style: { marginLeft: 6, marginBottom: 1 } }, /* @__PURE__ */ React10.createElement(MethodCall, { call, callsById }))
  ), /* @__PURE__ */ React10.createElement(RowActions, null, childCallIds?.length > 0 && /* @__PURE__ */ React10.createElement(
    WithTooltip,
    {
      hasChrome: false,
      tooltip: /* @__PURE__ */ React10.createElement(Note2, { note: `${isCollapsed ? "Show" : "Hide"} interactions` })
    },
    /* @__PURE__ */ React10.createElement(StyledIconButton2, { containsIcon: true, onClick: toggleCollapsed }, /* @__PURE__ */ React10.createElement(Icon.ListUnordered, null))
  ))), call.status === CallStates.ERROR && call.exception?.callId === call.id && /* @__PURE__ */ React10.createElement(Exception, { exception: call.exception }));
};

// src/components/InteractionsPanel.tsx
var Container = styled.div(({ theme: theme2, withException }) => ({
  minHeight: "100%",
  background: theme2.background.content,
  ...withException && {
    backgroundColor: theme2.base === "dark" ? transparentize(0.93, theme2.color.negative) : theme2.background.warning
  }
}));
var CaughtException = styled.div(({ theme: theme2 }) => ({
  padding: 15,
  fontSize: theme2.typography.size.s2 - 1,
  lineHeight: "19px"
}));
var CaughtExceptionCode = styled.code(({ theme: theme2 }) => ({
  margin: "0 1px",
  padding: 3,
  fontSize: theme2.typography.size.s1 - 1,
  lineHeight: 1,
  verticalAlign: "top",
  background: "rgba(0, 0, 0, 0.05)",
  border: `1px solid ${theme2.appBorderColor}`,
  borderRadius: 3
}));
var CaughtExceptionTitle = styled.div({
  paddingBottom: 4,
  fontWeight: "bold"
});
var CaughtExceptionDescription = styled.p({
  margin: 0,
  padding: "0 0 20px"
});
var CaughtExceptionStack = styled.pre(({ theme: theme2 }) => ({
  margin: 0,
  padding: 0,
  fontSize: theme2.typography.size.s1 - 1
}));
var InteractionsPanel = React10.memo(
  function InteractionsPanel2({
    calls,
    controls,
    controlStates,
    interactions,
    fileName,
    hasException,
    caughtException,
    isPlaying,
    pausedAt,
    onScrollToEnd,
    endRef
  }) {
    return /* @__PURE__ */ React10.createElement(Container, { withException: !!caughtException }, (interactions.length > 0 || hasException) && /* @__PURE__ */ React10.createElement(
      Subnav,
      {
        controls,
        controlStates,
        status: (
          // eslint-disable-next-line no-nested-ternary
          isPlaying ? CallStates.ACTIVE : hasException ? CallStates.ERROR : CallStates.DONE
        ),
        storyFileName: fileName,
        onScrollToEnd
      }
    ), /* @__PURE__ */ React10.createElement("div", { "aria-label": "Interactions list" }, interactions.map((call) => /* @__PURE__ */ React10.createElement(
      Interaction,
      {
        key: call.id,
        call,
        callsById: calls,
        controls,
        controlStates,
        childCallIds: call.childCallIds,
        isHidden: call.isHidden,
        isCollapsed: call.isCollapsed,
        toggleCollapsed: call.toggleCollapsed,
        pausedAt
      }
    ))), caughtException && !caughtException.message?.startsWith("ignoredException") && /* @__PURE__ */ React10.createElement(CaughtException, null, /* @__PURE__ */ React10.createElement(CaughtExceptionTitle, null, "Caught exception in ", /* @__PURE__ */ React10.createElement(CaughtExceptionCode, null, "play"), " function"), /* @__PURE__ */ React10.createElement(CaughtExceptionDescription, null, "This story threw an error after it finished rendering which means your interactions couldn' t be run.Go to this story' s play function in ", fileName, " to fix."), /* @__PURE__ */ React10.createElement(CaughtExceptionStack, { "data-chromatic": "ignore" }, caughtException.stack || `${caughtException.name}: ${caughtException.message}`)), /* @__PURE__ */ React10.createElement("div", { ref: endRef }), !isPlaying && !caughtException && interactions.length === 0 && /* @__PURE__ */ React10.createElement(Placeholder, null, "No interactions found", /* @__PURE__ */ React10.createElement(
      Link,
      {
        href: "https://storybook.js.org/docs/react/writing-stories/play-function",
        target: "_blank",
        withArrow: true
      },
      "Learn how to add interactions to your story"
    )));
  }
);

// src/Panel.tsx
var INITIAL_CONTROL_STATES = {
  start: false,
  back: false,
  goto: false,
  next: false,
  end: false
};
var getInteractions = ({
  log,
  calls,
  collapsed,
  setCollapsed
}) => {
  const callsById = /* @__PURE__ */ new Map();
  const childCallMap = /* @__PURE__ */ new Map();
  return log.map(({ callId, ancestors, status }) => {
    let isHidden = false;
    ancestors.forEach((ancestor) => {
      if (collapsed.has(ancestor)) {
        isHidden = true;
      }
      childCallMap.set(ancestor, (childCallMap.get(ancestor) || []).concat(callId));
    });
    return { ...calls.get(callId), status, isHidden };
  }).map((call) => {
    const status = call.status === CallStates.ERROR && callsById.get(call.ancestors.slice(-1)[0])?.status === CallStates.ACTIVE ? CallStates.ACTIVE : call.status;
    callsById.set(call.id, { ...call, status });
    return {
      ...call,
      status,
      childCallIds: childCallMap.get(call.id),
      isCollapsed: collapsed.has(call.id),
      toggleCollapsed: () => setCollapsed((ids) => {
        if (ids.has(call.id)) {
          ids.delete(call.id);
        } else {
          ids.add(call.id);
        }
        return new Set(ids);
      })
    };
  });
};
var Panel = memo(function PanelMemoized({ storyId }) {
  const [addonState, set] = useAddonState(ADDON_ID, {
    controlStates: INITIAL_CONTROL_STATES,
    isErrored: false,
    pausedAt: void 0,
    interactions: [],
    isPlaying: false,
    hasException: false,
    caughtException: void 0,
    interactionsCount: 0
  });
  const [scrollTarget, setScrollTarget] = useState(void 0);
  const [collapsed, setCollapsed] = useState(/* @__PURE__ */ new Set());
  const {
    controlStates = INITIAL_CONTROL_STATES,
    isErrored = false,
    pausedAt = void 0,
    interactions = [],
    isPlaying = false,
    caughtException = void 0
  } = addonState;
  const log = useRef([]);
  const calls = useRef(/* @__PURE__ */ new Map());
  const setCall = ({ status, ...call }) => calls.current.set(call.id, call);
  const endRef = useRef();
  useEffect(() => {
    let observer;
    if (global.IntersectionObserver) {
      observer = new global.IntersectionObserver(
        ([end]) => setScrollTarget(end.isIntersecting ? void 0 : end.target),
        { root: global.document.querySelector("#panel-tab-content") }
      );
      if (endRef.current)
        observer.observe(endRef.current);
    }
    return () => observer?.disconnect();
  }, []);
  const emit = useChannel(
    {
      [EVENTS.CALL]: setCall,
      [EVENTS.SYNC]: (payload) => {
        set((s) => {
          const list = getInteractions({
            log: payload.logItems,
            calls: calls.current,
            collapsed,
            setCollapsed
          });
          return {
            ...s,
            controlStates: payload.controlStates,
            pausedAt: payload.pausedAt,
            interactions: list,
            interactionsCount: list.filter(({ method }) => method !== "step").length
          };
        });
        log.current = payload.logItems;
      },
      [STORY_RENDER_PHASE_CHANGED]: (event) => {
        if (event.newPhase === "preparing") {
          set((s) => ({
            controlStates: INITIAL_CONTROL_STATES,
            isErrored: false,
            pausedAt: void 0,
            interactions: [],
            isPlaying: false,
            isRerunAnimating: false,
            scrollTarget,
            collapsed: /* @__PURE__ */ new Set(),
            hasException: false,
            caughtException: void 0,
            interactionsCount: 0
          }));
          return;
        }
        set((s) => ({
          ...s,
          isPlaying: event.newPhase === "playing",
          pausedAt: void 0,
          ...event.newPhase === "rendering" ? {
            isErrored: false,
            caughtException: void 0
          } : {}
        }));
      },
      [STORY_THREW_EXCEPTION]: () => {
        set((s) => ({ ...s, isErrored: true }));
      },
      [PLAY_FUNCTION_THREW_EXCEPTION]: (e) => {
        if (e?.message !== IGNORED_EXCEPTION.message) {
          set((s) => ({ ...s, caughtException: e }));
        } else {
          set((s) => ({ ...s, caughtException: void 0 }));
        }
      }
    },
    [collapsed]
  );
  useEffect(() => {
    set((s) => {
      const list = getInteractions({
        log: log.current,
        calls: calls.current,
        collapsed,
        setCollapsed
      });
      return {
        ...s,
        interactions: list,
        interactionsCount: list.filter(({ method }) => method !== "step").length
      };
    });
  }, [collapsed]);
  const controls = useMemo(
    () => ({
      start: () => emit(EVENTS.START, { storyId }),
      back: () => emit(EVENTS.BACK, { storyId }),
      goto: (callId) => emit(EVENTS.GOTO, { storyId, callId }),
      next: () => emit(EVENTS.NEXT, { storyId }),
      end: () => emit(EVENTS.END, { storyId }),
      rerun: () => {
        emit(FORCE_REMOUNT, { storyId });
      }
    }),
    [storyId]
  );
  const storyFilePath = useParameter("fileName", "");
  const [fileName] = storyFilePath.toString().split("/").slice(-1);
  const scrollToTarget = () => scrollTarget?.scrollIntoView({ behavior: "smooth", block: "end" });
  const hasException = !!caughtException || interactions.some((v) => v.status === CallStates.ERROR);
  if (isErrored) {
    return /* @__PURE__ */ React10__default.createElement(Fragment, { key: "interactions" });
  }
  return /* @__PURE__ */ React10__default.createElement(Fragment, { key: "interactions" }, /* @__PURE__ */ React10__default.createElement(
    InteractionsPanel,
    {
      calls: calls.current,
      controls,
      controlStates,
      interactions,
      fileName,
      hasException,
      caughtException,
      isPlaying,
      pausedAt,
      endRef,
      onScrollToEnd: scrollTarget && scrollToTarget
    }
  ));
});
var TabIcon = styled(StatusIcon)({
  marginLeft: 5
});

// src/manager.tsx
function Title() {
  const [addonState = {}] = useAddonState(ADDON_ID);
  const { hasException, interactionsCount } = addonState;
  return /* @__PURE__ */ React10__default.createElement("div", null, /* @__PURE__ */ React10__default.createElement(Spaced, { col: 1 }, /* @__PURE__ */ React10__default.createElement("span", { style: { display: "inline-block", verticalAlign: "middle" } }, "Interactions"), interactionsCount && !hasException ? /* @__PURE__ */ React10__default.createElement(Badge, { status: "neutral" }, interactionsCount) : null, hasException ? /* @__PURE__ */ React10__default.createElement(TabIcon, { status: CallStates.ERROR }) : null));
}
addons.register(ADDON_ID, (api) => {
  addons.add(PANEL_ID, {
    type: types.PANEL,
    title: Title,
    match: ({ viewMode }) => viewMode === "story",
    render: ({ active }) => {
      const newLocal = useCallback(({ state }) => {
        return {
          storyId: state.storyId
        };
      }, []);
      return /* @__PURE__ */ React10__default.createElement(AddonPanel, { active }, /* @__PURE__ */ React10__default.createElement(Consumer, { filter: newLocal }, ({ storyId }) => /* @__PURE__ */ React10__default.createElement(Panel, { storyId })));
    }
  });
});
